export enum FaxChannel {
  CREATE = 'fax::create',
  EDIT = 'fax::patch',
  DELETE = 'fax::delete',
}
